import { render, staticRenderFns } from "./ResellerPaymentViewLogs.vue?vue&type=template&id=5dd42f44"
import script from "./ResellerPaymentViewLogs.vue?vue&type=script&lang=js"
export * from "./ResellerPaymentViewLogs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports